/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useEffect } from 'react';
import { USER_DATECHANGEFINAL_STATE_CHANGE} from '../../../redux/constanst/index';
import { useDispatch, connect } from 'react-redux';
import { mapStateToProps, mesArr } from '../models/buscar';
import { years } from './../models/buscar';



function CustomizedSelects(props) {
  const dispatch = useDispatch();
  const [date, setDate] = React.useState("")

  const [finalChange, setFinalChange] = React.useState({
    dia: null,
    mes: null,
    year: null
  })

  React.useEffect(() => {
    if (date === "") {
      setDate(props.dateIn)
    }

  

  }, [props.dateIn, props.dateChangeFinal])

  useEffect(() => {
    
    if (Object.entries(date).length === 0 || !finalChange.dia) {
      if(date.final){
        let mesNum =0;
            switch (date.final.mes) {
              case "Enero":
                mesNum = 1;
                break
              case "Febrero":
                mesNum = 2;
                break
              case "Marzo":
                mesNum = 3
                break
              case "Abril":
                mesNum = 4
                break
              case "Mayo":
                mesNum = 5
                break
              case "Junio":
                mesNum = 6
                break
              case "Julio":
                mesNum = 7
                break
              case "Agosto":
                mesNum = 8
                break
              case "Septiembre":
                mesNum = 9
                break
              case "Octubre":
                mesNum = 10
                break
              case "Noviembre":
                mesNum = 11
                break
              case "Diciembre":
                mesNum = 12
                break
              default:
                break
            }
        setFinalChange({
          dia: parseInt(date.final.dia),
          mes: mesNum
        })
        
        
      }
        
    }
  
  })

  const handlerChangeStoreF =  (fecha, valor) => {
    let fechaLista;
    if(fecha === "dia"){
      fechaLista = {
        dia: valor,
        mes: props.dateChangeFinal.mes,
        year: props.dateChangeFinal.year,
      }
    }
      else if(fecha === "mes"){ 
        fechaLista = {
          dia: props.dateChangeFinal.dia,
          mes: valor,
          year: props.dateChangeFinal.year,
        }
      }
      else { 
        fechaLista = {
          dia: props.dateChangeFinal.dia,
          mes: props.dateChangeFinal.mes,
          year: valor,
        }
      }
    dispatch({ type: USER_DATECHANGEFINAL_STATE_CHANGE, dateChangeFinal: fechaLista })
  }

  return (
    <div>
      <FormControl sx={{ m: 0.7 }} variant="standard">
        <Autocomplete
          size="small"
          disablePortal
          id="combo-box-demo"
          options={días}
       
          onInputChange={(event, newInputValue) => {
            handlerChangeStoreF('dia', parseInt(newInputValue))
          }}
          sx={{ width: 80, maxWidth: 80 }}
          renderInput={(params) => <TextField {...params} label={Object.values(props.dateChangeFinal).length <= 0 ? "Día" : props.dateChangeFinal.dia} />}
        />
      </FormControl>
      <FormControl sx={{ m: 0.7 }} variant="standard">
        
        <Autocomplete
          size="small"
          disablePortal
          id="combo-box-demo"
          labelId="demo-simple-select-label"
          options={meses}
          onInputChange={(event, newInputValue) => {
            let mesNum =0;
            switch (newInputValue) {
              case "Enero":
                mesNum = 1;
                break
              case "Febrero":
                mesNum = 2;
                break
              case "Marzo":
                mesNum = 3
                break
              case "Abril":
                mesNum = 4
                break
              case "Mayo":
                mesNum = 5
                break
              case "Junio":
                mesNum = 6
                break
              case "Julio":
                mesNum = 7
                break
              case "Agosto":
                mesNum = 8
                break
              case "Septiembre":
                mesNum = 9
                break
              case "Octubre":
                mesNum = 10
                break
              case "Noviembre":
                mesNum = 11
                break
              case "Diciembre":
                mesNum = 12
                break
              default:
                break
            }
            handlerChangeStoreF('mes',mesNum )
          }}
          sx={{ width: 200, maxWidth: 200 }}
          renderInput={(params) => <TextField {...params} label={Object.values(props.dateChangeFinal).length <= 0 ? "Mes" : mesArr[(props.dateChangeFinal.mes)]} />}
        />
      </FormControl>
      <FormControl sx={{ m: 0.7 }} variant="standard">
        <Autocomplete
          size="small"
          disablePortal
          id="combo-box-demo"
          options={years}
       
          onInputChange={(event, newInputValue) => {
            handlerChangeStoreF('year', parseInt(newInputValue))
          }}
          sx={{ width: 80, maxWidth: 80 }}
          renderInput={(params) => <TextField {...params} label={props.dateChangeFinal.year} />}
        />
      </FormControl>
    </div>
  );
}


export default connect(mapStateToProps, null)(CustomizedSelects);


const días = [
  { label: "1", },
  { label: "2", },
  { label: "3", },
  { label: "4", },
  { label: "5", },
  { label: "6", },
  { label: "7", },
  { label: "8", },
  { label: "9", },
  { label: "10", },
  { label: "11", },
  { label: "12", },
  { label: "13", },
  { label: "14", },
  { label: "15", },
  { label: "16", },
  { label: "17", },
  { label: "18", },
  { label: "19", },
  { label: "20", },
  { label: "21", },
  { label: "22", },
  { label: "23", },
  { label: "24", },
  { label: "25", },
  { label: "26", },
  { label: "27", },
  { label: "28", },
  { label: "29", },
  { label: "30", },
  { label: "31" ,},

]

const meses = [
  { label: "Enero", },
  { label: "Febrero", },
  { label: "Marzo", },
  { label: "Abril", },
  { label: "Mayo", },
  { label: "Junio", },
  { label: "Julio", },
  { label: "Agosto", },
  { label: "Septiembre", },
  { label: "Octubre", },
  { label: "Noviembre", },
  { label: "Diciembre", },

]

